import moment from 'moment'
moment.locale('fr');
import css from './style.css'
import websitecss from './website.css'
/*import { DiscussionView } from './views/discussion/discussion';*/
/*import { Paiement } from './views/paiement/paiement';*/
/*import { CotationView } from './views/cotation/cotation';*/
import { RecoteBootstraper } from './views/recote/recoteDetails';
import { RechercheView } from './views/recherche/recherche';

var modules = {
    /*discussion: DiscussionView,*/
    /*paiement: Paiement,*/
    /*evaluer: CotationView,*/
    cote: RecoteBootstraper,
    recherche: RechercheView
};

window.camelCased = function (myString) { return myString.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); }); }
$(function () {
    $('head').append('<style type="text/css">' + css + '</style>');
    $('head').append('<style type="text/css">' + websitecss + '</style>');
    bootstrapContent($('body'));
});
window.bootstrapContent = function (el) {
    
    $(el).find('[data-module]').each(function () {
        var module_name = $(this).attr('data-module');
        
        if ($(this).attr('data-module') in modules) {
            
            $(this).prop('data-module', false); // remove to avoid bootstrapping again
            var moduleOptions = { el: this };
            $.each(this.attributes, function () {
                // this.attributes is not a plain object, but an array
                // of attribute nodes, which contain both the name and value
                console.log('DSADSADASDSA')
                if (this.specified && this.name.substr(0, 5) == 'data-') {
                    moduleOptions[camelCased(this.name.substr(5))] = this.value
                }
            });
            var objClass = modules[module_name];
            new objClass(moduleOptions).render();
        } else {
            console.error('Module ' + module_name + ' not found :(');
        }
    });
}
